import { useEffect, useState } from "react";
import { http } from "../lib/api";

const SPEED = { slow: 42, medium: 26, fast: 15 };
const SEP = { star: "✦", dot: "•", slash: "/", cross: "✕", logo: "SS" };

function Strip({ m }) {
  const dur = SPEED[m.speed] || 26;
  const variant = m.variant || "white_on_black";
  const base = {
    white_on_black: "bg-[#070708] text-zinc-200 border-y border-zinc-800",
    black_on_white: "bg-zinc-100 text-zinc-900 border-y border-zinc-300",
    white_on_cobalt: "text-white border-y border-blue-500",
    outline_on_black: "bg-[#070708] border-y border-zinc-800",
  }[variant] || "bg-[#070708] text-zinc-200";
  const wrapStyle = variant === "white_on_cobalt" ? { background: "var(--ss-accent)" } : {};
  const items = m.items || [];
  const sep = SEP[m.separator] || "✦";
  const outline = variant === "outline_on_black";

  return (
    <div className={`ss-marquee overflow-hidden ${base}`} style={{ height: m.height || 48, ...wrapStyle }}
      data-testid="marquee-strip">
      <div className="h-full flex items-center">
        <div className={`ss-marquee-track pausable ${m.direction === "right" ? "rev" : ""}`}
          style={{ animationDuration: `${dur}s` }}>
          {[0, 1].map((k) => (
            <span key={k} className="inline-flex items-center">
              {items.map((it, i) => (
                <span key={i} className="inline-flex items-center">
                  <span className="font-display text-xl sm:text-3xl tracking-widest uppercase px-6"
                    style={outline ? { WebkitTextStroke: "1px #52525b", color: "transparent" } : {}}>
                    {it.text}
                  </span>
                  <span className="text-accent font-display text-lg px-2 select-none">{sep}</span>
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Marquee({ placement }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    http.get(`/marquees?placement=${placement}`).then((r) => setList(r.data)).catch(() => {});
  }, [placement]);
  if (!list.length) return null;
  return <>{list.map((m) => <Strip key={m.id} m={m} />)}</>;
}
